import React from 'react'
import { Text, View } from 'react-native'
import { useTheme } from '../../hooks/useTheme'
import { TURN_CARD_SPACING } from '../../lib/turnPanelAppearance'

interface TurnActionCounterProps {
  action: 'attacks' | 'fortifies'
  used: number
  limit: number | null
  compact: boolean
}

/** Shared phase counter: unlimited actions still show their actual usage. */
export function TurnActionCounter({ action, used, limit, compact }: TurnActionCounterProps) {
  const { theme } = useTheme()
  const label = action === 'attacks' ? 'Attacks' : 'Fortifies'
  return (
    // Never wraps mid-word ("FORTIFI / ES"): the buttons beside it give way.
    <View style={{ flexShrink: 0, paddingLeft: TURN_CARD_SPACING.counterInset }}>
      <Text testID={`${action}-counter`}
        numberOfLines={1}
        accessibilityLabel={`${label}: ${used} used, ${limit === null ? 'unlimited' : `${limit} allowed`}`}
        className={`${compact ? 'text-[11px]' : 'text-sm'} font-stencil uppercase text-ink-soft`}
        style={action === 'attacks' ? { color: theme === 'dark' ? '#a1a1aa' : '#52525b' } : undefined}>
        {label}{' '}
        <Text className={action === 'attacks' ? 'text-blood' : 'text-olive-up'}>
          {used}/{limit === null ? <Text className="font-sans font-bold">∞</Text> : limit}
        </Text>
      </Text>
    </View>
  )
}
